import { Pagination } from '../../../../../../models/pagination-table.model';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ITransporterMember } from '../../../../../../models/transporter-member.model';
import { TableOptions } from '../../../../../../services/i-bary-table-fetch-service';
import { PATHS } from '../../../../../../models/bary-paths.model';
import { TranslateService } from '@ngx-translate/core';
import { ITransporterGroup } from '../../../../../../models/transporter-group.model';
import { TransporterGroupService } from '../../../../../../services/transporterGroup.service';
import { BaryModalService } from '../../../../../../services/bary-modal.service';

@Component({
  selector: 'jhi-transporter-groups-list',
  templateUrl: './transporter-groups-list.component.html',
  styleUrls: ['./transporter-groups-list.component.scss'],
})
export class TransporterGroupsListComponent {
  @Input() transporterGroups: ITransporterGroup[] | undefined;
  @Input() tableOptions?: TableOptions;
  @Input() pagination!: Pagination;
  @Output() paginationChange = new EventEmitter<Pagination>();

  PATHS = PATHS;

  constructor(protected modalService: BaryModalService, protected translateService: TranslateService, protected transporterGroupService: TransporterGroupService) {}

  trackId(index: number, item: ITransporterMember): number {
    return item.id!;
  }

  transition(): void {
    this.paginationChange.emit(this.pagination);
  }

  delete(transporterGroup: ITransporterGroup): void {
    const message = this.translateService.instant('transporterMember.delete.group.middle.question', {
      name: transporterGroup.name,
    });
    this.modalService
      .openConfirm(message)
      .action()
      .subscribe(action => {
        if (action.submit) {
          this.transporterGroupService.delete(transporterGroup.id!).subscribe(() => {
            this.transition();
          });
        }
      });
  }
}
